// extracted by mini-css-extract-plugin
export var approachSection = "HowTwinWork-module--approachSection--IMeWf";
export var approachTitle = "HowTwinWork-module--approachTitle--Nr2J6";
export var headerSection = "HowTwinWork-module--headerSection--sAC31";
export var howTwinWorkWrapper = "HowTwinWork-module--howTwinWorkWrapper--HPLLZ";
export var mainDescription = "HowTwinWork-module--mainDescription--mRK+s";
export var mainTitle = "HowTwinWork-module--mainTitle--dMEAP";